import React from "react";
import Pagination from "../../Pagination/Pagination";
import moment from "moment";
import Loader from "../Loader/Loader";
import { API_URL } from "../../config";
import axios from "axios";
import EmptyState from "../../Components/EmptyState";

export default function HistoryList({ historyData }) {
  const [loader, setLoader] = React.useState(true);
  const [showPrePage, setShowPrePage] = React.useState(10);
  console.log("historyData::: ", historyData);
  const [pagination, setPagination] = React.useState({
    start: 0,
    end: showPrePage,
  });
  const [filteredOptions, setFilteredOptions] = React.useState([]);
  const [selectType, setSelectType] = React.useState("");
  const [pageNumber, setPageNumber] = React.useState(1);
  const [recordLength, setRecordLength] = React.useState(10);
  const [totalLength, setTotalLength] = React.useState("");

  console.log("recordLength::: ", recordLength);

  React.useEffect(() => {
    getHistoryList();
  }, [pageNumber, recordLength, selectType]);

  const onPaginationChange = (start, end) => {
    setPagination({ start: start, end: end });
  };

  const updateShowPerpagevalue = (value) => {
    setShowPrePage(value);
    setPagination({ start: 0, end: value });
  };

  const getHistoryList = () => {
    setLoader(true);
    axios
      .post(`${API_URL}/api/admin/player/get-single-player-history`, {
        playerId: historyData,
        pageNumber: pageNumber,
        recordLength: recordLength,
        search: selectType,
      })
      .then((response) => {
        const wrapper = response?.data?.data;
        // API may return: { totalLength, historyData: [...] }
        // OR:             { totalLength, data: [...] }
        // OR:             an array directly
        let rows = [];
        let total = 0;
        if (Array.isArray(wrapper)) {
          // data itself is the array
          rows = wrapper;
          total = wrapper.length;
        } else if (wrapper && typeof wrapper === "object") {
          rows = Array.isArray(wrapper.historyData)
            ? wrapper.historyData
            : Array.isArray(wrapper.data)
            ? wrapper.data
            : [];
          total =
            typeof wrapper.totalLength === "number"
              ? wrapper.totalLength
              : rows.length;
        }
        setFilteredOptions(rows);
        setTotalLength(total);
        setLoader(false);
      })
      .catch((error) => {
        console.log("getBranch error :::", error.message);
        setLoader(false);
      });
  };

  return (
    <div style={{ overflow: "scroll" }}>
      <div
        className="form-group"
        style={{ width: "300px", display: "flex", alignItems: "end" }}
      >
        <label htmlFor="password" className="px-2">
          Filter
        </label>
        <select
          name="bot"
          value={selectType}
          onChange={(e) => {
            setPageNumber(1);
            setRecordLength(10);
            setSelectType(e.target.value);
          }}
          className={`mt-2 form-control`}
        >
          <option value={0}>All</option>
          <option value={2}>Deposit</option>
          <option value={3}>Withdraw</option>
          <option value={21}>Smash Block</option>
          <option value={22}>Tic Tac Toe</option>
          <option value={23}>Block Blast</option>
          <option value={24}>Word Book</option>
          <option value={25}>Number Puzzle 2248</option>
          <option value={26}>Logic Line</option>
          <option value={27}>Candy Cream</option>
        </select>
      </div>
      <table id="" class="table table-bordered table-striped">
        <thead>
          <tr>
            <th style={{ textAlign: "center" }}>Id</th>
            <th style={{ textAlign: "center" }}>Player Id</th>
            <th style={{ textAlign: "center" }}>Game Name</th>
            <th style={{ textAlign: "center" }}>Transaction Type</th>
            <th style={{ textAlign: "center" }}>Amount</th>
            <th style={{ textAlign: "center" }}>Note</th>
            <th style={{ textAlign: "center" }}>Created At</th>
          </tr>
        </thead>
        <tbody>
          {!loader && (
            <>
              {filteredOptions.length > 0 ? (
                <>
                  {filteredOptions?.map((item, index) => {
                    return (
                      <>
                        <tr key={index} style={{ textAlign: "center" }}>
                          <td style={{ textAlign: "center" }}>
                            {pageNumber === 1
                              ? index + 1
                              : index +
                                1 +
                                pageNumber * recordLength -
                                recordLength}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.playerId ? item.playerId : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.gameNo === 1
                              ? "Smash Block"
                              : item.gameNo === 2
                              ? "Tic Tac Toe"
                              : item.gameNo === 3
                              ? "Block Blast"
                              : item.gameNo === 4
                              ? "Word Book"
                              : item.gameNo === 5
                              ? "Nuber Puzzle"
                              : item.gameNo === 6
                              ? "Logic Line"
                              : item.gameNo === 7
                              ? "Candy Cream"
                              : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.transactionType === 0 ? "Debit" : "Credit"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {Math.round(item.amount * 100) / 100}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {item.note === 0
                              ? "Win"
                              : item.note === 1
                              ? "Bet"
                              : item.note === 2
                              ? "Add Money"
                              : item.note === 3
                              ? "Withdraw"
                              : item.note === 4
                              ? "Reward"
                              : item.note === 5
                              ? "Refund"
                              : "-"}
                          </td>
                          <td style={{ textAlign: "center" }}>
                            {moment(item.createdAt).format("DD/MM/YYYY")}
                          </td>
                        </tr>
                      </>
                    );
                  })}
                </>
              ) : (
                <EmptyState colSpan={7} message="No History Found" subMessage="No game or transaction history found for this player." />
              )}
            </>
          )}
        </tbody>
      </table>
      <div
        className="mt-4"
        style={{ display: "flex", justifyContent: "center" }}
      >
        {loader && <Loader />}
      </div>

      {filteredOptions.length != 0 && (
        <Pagination
          updateShowPerpagevalue={updateShowPerpagevalue}
          showPrePage={showPrePage}
          onPaginationChange={onPaginationChange}
          total={totalLength}
          paginationTypeApi={true}
          pageNumber={pageNumber}
          setPageNumber={setPageNumber}
          recordLength={recordLength}
          setRecordLength={setRecordLength}
          totalLength={totalLength}
        />
      )}
    </div>
  );
}
